import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isUserRelationshipTarget } from '@core-engine/schema/system-relationships/is-user-relationship-target.js'
import { renderBuildRelationshipDataTypesRenderer } from '@next-adapter/templates/renderers/generators/actions/action-helpers/build-relationship-data-types.js'
import { relationshipDataTypeName } from './relationship-data-type-name.js'
export function buildRelationshipDataTypes(fields: SchemaField[]): string | null {
  const relationshipFields = fields.filter((field) => field.type === 'relationship')
  if (relationshipFields.length === 0) return null

  const typeDeclarations = new Map<string, string>()
  for (const field of relationshipFields) {
    const typeName = relationshipDataTypeName(field)
    if (typeDeclarations.has(typeName)) continue

    typeDeclarations.set(
      typeName,
      isUserRelationshipTarget(field.relationship)
        ? renderBuildRelationshipDataTypesRenderer({
            kind: 'renderBuildRelationshipDataTypesComponentTemplate',
            props: { typeName: typeName }
          })
        : renderBuildRelationshipDataTypesRenderer({
            kind: 'renderBuildRelationshipDataTypesComponentDetailsTemplate',
            props: { typeName: typeName }
          })
    )
  }

  return Array.from(typeDeclarations.values()).join('\n\n')
}
